import React from "react";

interface IProfileTemplateProps {
  className?: string;
}

export const ProfileTemplate = ({ className }: IProfileTemplateProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16 4C16.55 4 17.0204 4.19622 17.4121 4.58789C17.8038 4.97956 18 5.45 18 6V22C18 22.55 17.8038 23.0204 17.4121 23.4121C17.0204 23.8038 16.55 24 16 24H4C3.45 24 2.97956 23.8038 2.58789 23.4121C2.19622 23.0204 2 22.55 2 22V6C2 5.45 2.19622 4.97956 2.58789 4.58789C2.97956 4.19622 3.45 4 4 4H16ZM10 20C9.06673 20 8.17514 20.1459 7.3252 20.4375C6.4752 20.7292 5.7 21.1667 5 21.75V22H15V21.75C14.3 21.1667 13.5248 20.7292 12.6748 20.4375C11.8249 20.1459 10.9333 20 10 20ZM20 0C21.1046 0 22 0.89543 22 2V19C22 20.1046 21.1046 21 20 21H19V19H20V2H7V3H5V2C5 0.89543 5.89543 0 7 0H20ZM4 20C4.85 19.3667 5.77539 18.8754 6.77539 18.5254C7.77533 18.1754 8.85009 18 10 18C11.1499 18 12.2247 18.1754 13.2246 18.5254C14.2246 18.8754 15.15 19.3667 16 20V6H4V20ZM10 9C10.9667 9 11.7913 9.34206 12.4746 10.0254C13.1579 10.7087 13.5 11.5333 13.5 12.5C13.5 13.4667 13.1579 14.2913 12.4746 14.9746C11.7913 15.6579 10.9667 16 10 16C9.03333 16 8.20872 15.6579 7.52539 14.9746C6.84206 14.2913 6.5 13.4667 6.5 12.5C6.5 11.5333 6.84206 10.7087 7.52539 10.0254C8.20872 9.34206 9.03333 9 10 9ZM10 11C9.58333 11 9.22917 11.1458 8.9375 11.4375C8.64583 11.7292 8.5 12.0833 8.5 12.5C8.5 12.9167 8.64583 13.2708 8.9375 13.5625C9.22917 13.8542 9.58333 14 10 14C10.4167 14 10.7708 13.8542 11.0625 13.5625C11.3542 13.2708 11.5 12.9167 11.5 12.5C11.5 12.0833 11.3542 11.7292 11.0625 11.4375C10.7708 11.1458 10.4167 11 10 11Z"
        fill="currentColor"
      />
    </svg>
  );
};
